import React from 'react'
import { Animation, PageContent, ContentMenu, ContentMenuTab, MapWidget, MapMenu, MapItem, MapTabs, MapTab, MessageTooltip, Text, Image, Panorama, MapOverlay, MapLayer } from 'components/library'
import { Layer, Popup } from 'components/library/widgets/map/components'

import mapBaseImage from 'components/library/widgets/map/assets/baseMap-01.svg'

import mapLayer1Image from './assets/maplayer_1_1_volleding-01.svg'
import mapLayer2Image from './assets/maplayer_1_1_centrum-01.svg'
import mapLayer3Image from './assets/maplayer_1_1_oost-01.svg'
import mapLayer4Image from './assets/maplayer_1_1_greenbevoegdheid-01.svg'
import mapLayer5Image from './assets/maplayer_1_1_2_punt_pieter-01.svg'

import img01 from './assets/RijbaanC3.jpg'
import img02 from './assets/RijbaanA21.jpg'
import img03 from './assets/RijbaanA22.jpg'
import img04 from './assets/RijbaanA26.jpg'
import img05 from './assets/PuntPieter.jpg'
import img07 from './assets/Uniform.jpeg'
import img06 from './assets/360dude.svg'
import img06dark from './assets/360dude_dark.svg' 

import './Aspect01.css'

class Aspect01 extends React.Component {

  state = {
    modalTitle: [
      'Op rijbaan C en D: Voor rijbaan C3',
      'Op rijbaan B: voor rijbaan A21',
      'Op rijbaan A: voor rijbaan A22.',
      'Op rijbaan A of B: voor rijbaan A26 (alleen als je richting rijbaan Q gaat)',
      'Punt Pieter: op alle rijbanen behalve komend vanaf rijbaan S2',
    ],

    modal: false,
    tab01tab: 0,
  }

  render() {
    return (
      <div className="Chapter01-Aspect01">
        <PageContent nospacing>
          <ContentMenu
          menuOnTop
          activeHasBackground
          tabs={[
            'Sleepgebieden',
            'Apron Control',
          ]} >

            <ContentMenuTab>
              <div className="Messages-layer">
                {this.state.tab01tab === 1 &&
                  <Animation name="appear">
                    <MessageTooltip>
                      <Text><strong>Onder Schiphol-Centrum valt:</strong></Text>
                      <ul>
                        <li>het Sierra-platform (exclusief kruising baan 06-24 / S2)</li>
                        <li>het door banen omsloten areaal Schiphol-Centrum, met uitzondering van rijbaan C, D, Y en Z</li>
                      </ul>
                    </MessageTooltip>
                  </Animation>
                }

                {this.state.tab01tab === 2 &&
                  <Animation name="appear">
                    <MessageTooltip>
                      <Text><strong>Onder Schiphol-Oost vallen:</strong></Text>
                      <ul>
                        <li>de platformen op Schiphol-Oost met toeleidende rijbanen</li>
                        <li>rijbaan G</li>
                      </ul>
                    </MessageTooltip>
                  </Animation>
                }

                {this.state.tab01tab === 3 &&
                  <Animation name="appear">
                    <MessageTooltip>
                      <Text><strong>Voor het uitvoeren van een sleepbeweging is geen bevoegdheid vereist op:</strong></Text>
                      <ul>
                        <li>platformen die direct grenzen aan hangars, zolang de brede rode klaringslijn niet overschreden wordt;</li>
                        <li>locaties die niet onder controle van LVNL vallen.</li>
                        <li>het Kilo-platform vereist dus geen sleepbevoegheid.  Sleepbewegingen waarbij een vliegtuig wordt versleept moeten wel met Apron Control afgestemd worden.</li>
                      </ul>
                    </MessageTooltip>
                  </Animation>
                }
              </div>

              <div className="Tab-01">
                <MapWidget
                  mapImage={mapBaseImage}
                  mapBounds={[[0, 0], [3556, 3406]]}
                  options={{ minZoom: -1.5 }}
                  liftStateSubTab={idx => this.setState({ tab01tab: idx })}>
                  <MapMenu>
                    <MapItem center={[1754,1703]} zoom={-1.5} label={'In- en Outbound'}>
                      <MapTabs>
                        <MapTab active={this.state.tab01tab === 0} center={[1754,1703]} zoom={-1.5} label="Volledig">
                          <Layer url={mapLayer1Image} bounds={[[0, 0], [3556, 3406]]}/>
                        </MapTab>
                        {/*<MapTab active={this.state.tab01tab === 1} center={[1598,1706]} zoom={-1.5} label="Centrum">*/}
                        {/*  <Layer url={mapLayer2Image} bounds={[[0, 0], [3556, 3406]]} />*/}
                        {/*</MapTab>*/}
                        {/*<MapTab active={this.state.tab01tab === 2} center={[1578,1706]} zoom={-1.5} label="Oost">*/}
                        {/*  <Layer url={mapLayer3Image} bounds={[[0, 0], [3556, 3406]]} />*/}
                        {/*</MapTab>*/}
                        {/*<MapTab active={this.state.tab01tab === 3} center={[1881,1703]} zoom={-1.5} label="Geen bevoegdheid">*/}
                        {/*  <Layer url={mapLayer4Image} bounds={[[0, 0], [3556, 3406]]} />*/}
                        {/*</MapTab>*/}
                      </MapTabs>
                    </MapItem>
                  </MapMenu>
                </MapWidget>
              </div>
            </ContentMenuTab>

            <ContentMenuTab>
              <div className="Tab-02">
                <MapWidget
                  mapImage={mapBaseImage}
                  mapBounds={[[0, 0], [3556, 3406]]}
                  options={{ minZoom: -1.5 }}>

                  <MapMenu>

                    <MapItem center={[1921,1706]} zoom={-1.5} label={'Hotspots'}>

                      <MapOverlay>

                        <MessageTooltip>
                          <Text>Als sleepchauffeur moet je je op een aantal locaties verplicht melden bij Apron Control. Afhankelijk van waar in het landingsterrein je je bevindt, is dit bij Apron-Noord of Apron-Zuid. </Text>
                        </MessageTooltip>

                        <div className="Map-panorama">

                          {this.state.modal !== false &&
                            <div className="Map-panorama-close">
                              {this.state.modalTitle.map((itm, idx) => (
                                this.state.modal === idx ?
                                 <div key={idx}><Text>{itm}</Text></div>
                                : null
                              ))}
                              <div onClick={() => this.setState({ modal: false })}>
                                X
                              </div>
                            </div>
                          }

                          {this.state.modal === 0 &&
                            <Panorama image={img01} />
                          }
                          {this.state.modal === 1 &&
                            <Panorama image={img02} />
                          }
                          {this.state.modal === 2 &&
                            <Panorama image={img03} />
                          }
                          {this.state.modal === 3 &&
                            <Panorama image={img04} />
                          }
                          {this.state.modal === 4 &&
                            <Panorama image={img05} />
                          }
                          {this.state.modal === 5 &&
                          <Image src={img07} />
                          }
                        </div>
                      </MapOverlay>

                      <MapLayer>

                        <Layer url={mapLayer5Image} bounds={[[0, 0], [3556, 3406]]}/>

                        <Popup onClick={() => this.setState({ modal: 0 })} position={[2688,707]} blue textCenter active={this.state.modal === 0}>
                          {this.state.modal !== 0 && <Image src={img06} aspectRatio={90} />}
                          {this.state.modal === 0 && <Image src={img06dark} aspectRatio={90} />}
                        </Popup>

                        <Popup onClick={() => this.setState({ modal: 1 })} position={[2202,820]} blue textCenter pinOnLeft active={this.state.modal === 1}>
                          {this.state.modal !== 1 && <Image src={img06} aspectRatio={90} />}
                          {this.state.modal === 1 && <Image src={img06dark} aspectRatio={90} />}
                        </Popup>

                        <Popup onClick={() => this.setState({ modal: 2 })} position={[2055,615]} blue textCenter pinOnRight active={this.state.modal === 2}>
                          {this.state.modal !== 2 && <Image src={img06} aspectRatio={90} />}
                          {this.state.modal === 2 && <Image src={img06dark} aspectRatio={90} />}
                        </Popup>

                        <Popup onClick={() => this.setState({ modal: 3 })} position={[1657,620]} blue textCenter active={this.state.modal === 3}>
                          {this.state.modal !== 3 && <Image src={img06} aspectRatio={90} />}
                          {this.state.modal === 3 && <Image src={img06dark} aspectRatio={90} />}
                        </Popup>

                        <Popup onClick={() => this.setState({ modal: 4 })} position={[1275,1072]} blue textCenter active={this.state.modal === 4}>
                          {this.state.modal !== 4 && <Image src={img06} aspectRatio={90} />}
                          {this.state.modal === 4 && <Image src={img06dark} aspectRatio={90} />}
                        </Popup>

                        <Popup onClick={() => this.setState({ modal: 5 })} position={[2480,812]} blue pinOnLeft textCenter active={this.state.modal === 5}>
                          {this.state.modal !== 5 && <Image src={img06} aspectRatio={90} />}
                          {this.state.modal === 5 && <Image src={img06dark} aspectRatio={90} />}
                        </Popup>
                      </MapLayer>
                    </MapItem>
                  </MapMenu>

                </MapWidget>
              </div>
            </ContentMenuTab>

          </ContentMenu>

        </PageContent>
      </div>
    )
  }
}

export default Aspect01



// WEBPACK FOOTER //
// ./src/content/chapters/01/01/Aspect01.js